import React from 'react';
import { Trans } from '@lingui/react';

export const euBannerText = i18n =>
  <Trans>
    Development of this website is co-financed by European Union funds from the European Regional Development Fund.
    Click <a href={i18n.t`https://learn.stemi.education/information-eu`}>here</a> for more information.
  </Trans>;
